import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.driver.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.drivers.saving',
        defaultMessage: 'Saving...'
    },
    makeChanges: {
        id: 'ml.policychange.drivers.makeChanges',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.drivers.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.drivers.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    addDriver: {
        id: 'ml.policychange.drivers.Add driver',
        defaultMessage: 'Add driver'
    },
    editDriver: {
        id: 'ml.policychange.drivers.Edit driver',
        defaultMessage: 'Edit driver'
    },
    addExcludedDriver: {
        id: 'ml.policychange.drivers.Add excluded driver',
        defaultMessage: 'Add excluded driver'
    },
    editExcludedDriver: {
        id: 'ml.policychange.drivers.Edit excluded driver',
        defaultMessage: 'Edit excluded driver'
    },
    removeExcludedDriver: {
        id: 'ml.policychange.drivers.Remove excluded driver',
        defaultMessage: 'Remove excluded driver'
    },
    driverExclusionHelpTitle: {
        id: 'ml.policychange.drivers.The driver must be either rated or excluded on this policy',
        defaultMessage: 'The driver must be either rated or excluded on this policy.'
    },
    driverExclusionHelpText: {
        id: 'ml.policychange.drivers.If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy',
        defaultMessage: 'The reason selected is not a valid reason to remove a driver. If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy.'
    },
    exlcusionNotAllowed: {
        id: 'ml.policychange.drivers.We require this person to be listed as a driver',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver.'
    },
    licensedSpouseCannotBeRemoved: {
        id: 'ml.policychange.drivers.Spouse cannot be removed as driver if licensed',
        defaultMessage: 'Spouse cannot be removed as driver if licensed.'
    },
    onlyDriverCannotBeExcluded: {
        id: 'ml.policychange.drivers.At least one driver must be listed as a rated driver to continue',
        defaultMessage: 'At least one driver must be listed as a rated driver to continue.'
    },
    alreadyExludedUnwanted: {
        id: 'ml.policychange.drivers.The reason selected is not a valid reason to remove the exclusion',
        defaultMessage: 'The reason selected is not a valid reason to remove the exclusion.'
    },
    alreadyExludedLicense: {
        id: 'ml.policychange.drivers.We require this driver to be excluded as their license is suspended or revoked',
        defaultMessage: 'We require this driver to be excluded as their license is suspended or revoked.'
    },
    ratedAddHeaderMessage: {
        id: 'ml.policychange.drivers.Please add the details for your new driver below',
        defaultMessage: 'Please add the details for your new driver below'
    },
    ratedEditHeaderMessage: {
        id: 'ml.policychange.drivers.Please update the details for this driver below',
        defaultMessage: 'Please update the details for this driver below'
    },
    drivers: {
        id: 'ml.policychange.drivers.Drivers',
        defaultMessage: 'Drivers'
    },
    addDriverSideBar: {
        id: 'ml.policychange.drivers.Add Driver',
        defaultMessage: 'Add Driver'
    },
    editDriverSideBar: {
        id: 'ml.policychange.drivers.Edit Driver',
        defaultMessage: 'Edit Driver'
    },
    removeDriverSideBar: {
        id: 'ml.policychange.drivers.Remove Driver',
        defaultMessage: 'Remove Driver'
    },
    addExcludedDriverSideBar: {
        id: 'ml.policychange.drivers.Add Excluded Driver',
        defaultMessage: 'Add Excluded Driver'
    },
    editExcludedDriverSideBar: {
        id: 'ml.policychange.drivers.Edit Excluded Driver',
        defaultMessage: 'Edit Excluded Driver'
    },
    removeExcludedDriverSideBar: {
        id: 'ml.policychange.drivers.Remove Excluded Driver',
        defaultMessage: 'Remove Excluded Driver'
    },
    boldWrapper: {
        id: 'ml.policychange.drivers.bold wrapper',
        defaultMessage: '{bold}'
    },
    accidentPreventionDiscount: {
        id: 'ml.policychange.drivers.bold accidentPreventionDiscount',
        defaultMessage: 'To receive the Accident Prevention Course discount, all drivers need to have completed a prevention course.'
    },
    duplicateSignalPhoneNumberMessage: {
        id: 'ml.policychange.drivers.duplicateSignalPhoneNumberMessage',
        defaultMessage: 'A different mobile phone number must be used for each driver that is selecting to participate in the Signal® program'
    }
});
